import { DnvLatLng } from 'dnv-lib';
import { ApplicationState, User, ProblemType, Group, ProblemAssignment, Role, LinkedCase, FromProblemLinkedCasePayload } from '../state-management';
import { Activity } from './activity';

export interface Problem {
  problemId: number;
  problemType_RefId: number;
  problemPriority_RefId: number;
  problemType_Name?: string;
  problemSubType_RefId?: number;
  priority: string;
  problemNo: string;
  problemDescription: string;
  reportedDate: Date;
  completedDate?: string;
  problemStatus: string;
  problemLocation: string;
  problemSource: string;
  group_RefId: number;
  problemGroup: string;
  problemRole?: string;
  latLng: DnvLatLng;
  assignedTo: string;
  //  isExpanded?: boolean;
  canCreateCodeCase?: boolean;
  canCreatePermit?: boolean;
  lastUpdatedAt: string;
  lastViewedAtDateTime: Date;
  lastViewedAt: string;
  lastUpdatedBy: number;
  [key: string]: any;
  problemRead: string;
  linkedStatus: string;
  linkedCases?: LinkedCase[];
  parent?: string;
  problemReceivedFrom: string;
}

export interface DuplicateProblemPayload {
  linkedCase: FromProblemLinkedCasePayload;
  activity: Activity;
  originalProblemNo: string;
  groupId: number;
  problemTypeId: number;
  ProblemSubType_RefId?: number;
  ProblemReceivedFrom_RefId? : number;
  userId?: number;
  roleId?: number;
  notes: string;
}

export interface ProblemDB {
  problem: NewProblem;
  reporter: ProblemContact[];
  owner: ContactDB[];
  shouldNotify: boolean;
}

export interface NewProblem {
  caseNo: string;
  group_RefId: number; // TODO confirm ???
  problemType_RefId: number;
  problemSubType_RefId?: number;
  description: string;
  // reported_Date: Date;
  problemStatus_RefId: number;
  problemSource_RefId: number;
  problemReceivedFrom_RefId: number;
  problemPriority_RefId: number;
  user_RefId?: number;
  role_RefId?: number;
  // contact: ContactDB;
  location_Description: string;
  location_Description_Origin: string;
  location_Longitude: number;
  location_Latitude: number;
  problem_Id?: number;
  createdBy: number;
}

export interface ContactDB {
  firstName: string;
  lastName: string;
  email: string;
  street: string;
  notes?: string;
}

export interface ContactPhone {
  contactPhone_Id?: number;
  phone: string;
  contact_RefId?: number;
  phoneType_RefId: number;
}

export interface PhoneType {
  phoneType_Id: number;
  phoneType_Name: string;
  active: boolean;
}

// for displaying in problem details
export interface ProblemContact {
  contactId?: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: ContactPhone[];
  street: string;
  notes?: string;
  contactType: string;
  companyName: string;
}

// getUser
export function getUserFromState(state: ApplicationState, userId: number): User | null {
  return state.menu.allUsersList.find(u => u.user_Id === userId) || null;
}

// getRole
export function getRoleFromState(state: ApplicationState, roleId: number): Role | null {
  return state.menu.problemRoleList.find(u => u.role_Id === roleId) || null;
}

// getGroup
export function getGroupFromState(state: ApplicationState, problemTypeId: number): Group | null {
  const problemAssignment: ProblemAssignment = state.menu.problemAssignments.find(p => p.problemType_RefId === problemTypeId);
  let group: Group = null;
  if (problemAssignment) {
    group = state.menu.problemGroupList.find(g => g.group_Id === problemAssignment.group_RefId) || null;
  }
  return group;
}
